import React, { Component } from 'react';
import { Icon, Button, Spin } from 'antd';
import moment from 'moment';
import request from '@/method/request';
import compute, { setKarte } from './compute';
import _ from 'lodash';
import './index.scss';

class index extends Component {
    state = {
        date: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        dataAll: [],
        year: 1,
        value: "OCC",
        loading: true
    }


    componentDidMount() {
        this.getData(this.state.date);
    }

    getData = async (date) => {
        try {
            const year = moment(date).format('YYYY');
            const month = moment(date).format('M');
            const day = moment(date).format('D');
            const res = await request(`/data/visualization?year=${year}&month=${month}&day=${day}`);
            this.setState({ loading: false, dataAll: compute(res.data || {}, day) }, () => {
                this.onChange(this.state.value, this.state.year)
            });
        } catch (error) {
            console.log(error, '数据加载错误！');
            this.setState({ loading: false });
        }
    }

    onChange = (value, year) => {
        this.setState({ value, year });
        const { date, dataAll } = this.state;
        const month = moment(date).format('M');
        const day = moment(date).format('D');
        const name = {
            "OCC": 'occ',
            "ADR": 'adr',
            "RevPAR": 'revpar',
            "客房收入": 'roomrev',
            "餐饮收入": 'fb',
            "总收入": 'total',
        };
        setKarte({
            title: value,
            day, month,
            type: value == 'OCC' ? 'percent' : '',
            dataY: [{
                name: "酒店",
                data: (year == 1 ? dataAll.data : dataAll.last).map(x => x[name[value]])
            }, {
                name: "区域",
                data: (year == 1 ? dataAll.area : dataAll.arealast).map(x => x[name[value]])
            }, {
                name: "收入区间",
                data: (year == 1 ? dataAll.interval : dataAll.intervallast).map(x => x[name[value]])
            }]
        })
    }

    render() {
        const { date, year, loading, value, dataAll: { data, last } } = this.state;
        const day = moment(date).format('D');
        let _data = data;
        if (value == 2) _data = last;

        return (
            <Spin spinning={loading}>
                <div className="data-Visualization">
                    <div className="title">1.2 Data Visualization 数据可视化
                </div>
                    <div className="title">1.2.1 Daily Visual Diagram 日数据可视化图表
                </div>

                    <div className="content">
                        <div className="item"
                            onClick={() => this.onChange("OCC", year)}
                            style={{ backgroundColor: _.get(_data, `${day - 1}.occ_g`) < 0 ? "#50B07A" : "#E37646" }}
                        >
                            <span className="name">OCC</span>
                            <span className="num">{(_.get(_data, `${day - 1}.occ`, 0) * 100).toFixed(1)}%</span>
                            <span className="data">
                                <span>较前日同时段</span>
                                <span>
                                    {(_.get(_data, `${day - 1}.occ_g`) * 100 || 0).toFixed(1)}%
                                {_.get(_data, `${day - 1}.occ_g`) > 0 && <Icon
                                        className="up"
                                        type="arrow-up" />}
                                    {_.get(_data, `${day - 1}.occ_g`) < 0 && <Icon
                                        className="down"
                                        type="arrow-down" />}
                                </span>
                            </span>
                        </div>
                        <div className="item"
                            onClick={() => this.onChange("ADR", year)}
                            style={{ backgroundColor: _.get(_data, `${day - 1}.adr_g`) < 0 ? "#50B07A" : "#E37646" }}
                        >
                            <span className="name">ADR</span>
                            <span className="num">{(_.get(_data, `${day - 1}.adr`, 0) * 1).toFixed(2)}</span>
                            <span className="data">
                                <span>较前日同时段</span>
                                <span>
                                    {(_.get(_data, `${day - 1}.adr_g`) * 100 || 0).toFixed(1)}%
                                {_.get(_data, `${day - 1}.adr_g`) > 0 && <Icon
                                        className="up"
                                        type="arrow-up" />}
                                    {_.get(_data, `${day - 1}.adr_g`) < 0 && <Icon
                                        className="down"
                                        type="arrow-down" />}
                                </span>
                            </span>
                        </div>
                        <div className="item"
                            style={{ backgroundColor: _.get(_data, `${day - 1}.revpar_g`) < 0 ? "#50B07A" : "#E37646" }}
                            onClick={() => this.onChange("RevPAR", year)}>
                            <span className="name">RevPAR</span>
                            <span className="num">{(_.get(_data, `${day - 1}.revpar`, 0) * 1).toFixed(2)}</span>
                            <span className="data">
                                <span>较前日同时段</span>
                                <span>
                                    {(_.get(_data, `${day - 1}.revpar_g`) * 100 || 0).toFixed(1)}%
                                {_.get(_data, `${day - 1}.revpar_g`) > 0 && <Icon
                                        className="up"
                                        type="arrow-up" />}
                                    {_.get(_data, `${day - 1}.revpar_g`) < 0 && <Icon
                                        className="down"
                                        type="arrow-down" />}
                                </span>
                            </span>
                        </div>
                        <div className="item"
                            style={{ backgroundColor: _.get(_data, `${day - 1}.roomrev_g`) < 0 ? "#50B07A" : "#E37646" }}
                            onClick={() => this.onChange("客房收入", year)}>
                            <span className="name">客房收入</span>
                            <span className="num">{(_.get(_data, `${day - 1}.roomrev`, 0) * 1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                            <span className="data">
                                <span>较前日同时段</span>
                                <span>
                                    {(_.get(_data, `${day - 1}.roomrev_g`) * 100 || 0).toFixed(1)}%
                                {_.get(_data, `${day - 1}.roomrev_g`) > 0 && <Icon
                                        className="up"
                                        type="arrow-up" />}
                                    {_.get(_data, `${day - 1}.roomrev_g`) < 0 && <Icon
                                        className="down"
                                        type="arrow-down" />}
                                </span>
                            </span>
                        </div>
                        <div className="item"
                            style={{ backgroundColor: _.get(_data, `${day - 1}.fb_g`) < 0 ? "#50B07A" : "#E37646" }}
                            onClick={() => this.onChange("餐饮收入", year)}>
                            <span className="name">餐饮收入</span>
                            <span className="num">{(_.get(_data, `${day - 1}.fb`, 0) * 1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                            <span className="data">
                                <span>较前日同时段</span>
                                <span>
                                    {(_.get(_data, `${day - 1}.fb_g`) * 100 || 0).toFixed(1)}%
                                {_.get(_data, `${day - 1}.fb_g`) > 0 && <Icon
                                        className="up"
                                        type="arrow-up" />}
                                    {_.get(_data, `${day - 1}.fb_g`) < 0 && <Icon
                                        className="down"
                                        type="arrow-down" />}
                                </span>
                            </span>
                        </div>
                        <div className="item"
                            style={{ backgroundColor: _.get(_data, `${day - 1}.total_g`) < 0 ? "#50B07A" : "#E37646" }}
                            onClick={() => this.onChange("总收入", year)}>
                            <span className="name">总收入</span>
                            <span className="num">{(_.get(_data, `${day - 1}.total`, 0) * 1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                            <span className="data">
                                <span>较前日同时段</span>
                                <span>
                                    {(_.get(_data, `${day - 1}.total_g`) * 100 || 0).toFixed(1)}%
                                {_.get(_data, `${day - 1}.total_g`) > 0 && <Icon
                                        className="up"
                                        type="arrow-up" />}
                                    {_.get(_data, `${day - 1}.total_g`) < 0 && <Icon
                                        className="down"
                                        type="arrow-down" />}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div className="selected">
                        <Button type={year == 1 ? 'primary' : ''}
                            onClick={() => this.onChange(value, 1)}
                        >今年</Button>
                        <Button
                            onClick={() => this.onChange(value, 2)}
                            type={year == 2 ? 'primary' : ''}>去年</Button>
                    </div>
                    <div className="chart-content">
                        <div id="chart" > </div>
                    </div>
                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/analysisChart/1.2.1/index.js